import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserPermissionsService } from '../services/user-permissions.service';

/**
 * Guard que redireciona /home para a primeira rota acessível ao usuário
 * Se não tiver acesso a nenhuma rota, redireciona para /no-permission
 */
export const homeRedirectGuard: CanActivateFn = (route, state) => {
  const permissionsService = inject(UserPermissionsService);
  const router = inject(Router);

  // Verificar se há token antes de verificar permissões
  if (typeof window === 'undefined' || !window.localStorage) {
    return router.createUrlTree(['/login']);
  }

  const token = localStorage.getItem('jwt') || localStorage.getItem('jwt-password');
  if (!token) {
    return router.createUrlTree(['/login']);
  }

  // Carregar permissões e redirecionar para primeira rota acessível
  return new Promise<import('@angular/router').UrlTree>((resolve) => {
    permissionsService.loadUserPermissions()
      .then(() => {
        const accessibleRoute = permissionsService.getFirstAccessibleRoute();
        
        if (accessibleRoute) {
          // Redirecionar para a primeira rota acessível
          resolve(router.createUrlTree([accessibleRoute]));
        } else {
          // Se não tem acesso a nenhuma rota, redirecionar para no-permission
          resolve(router.createUrlTree(['/no-permission']));
        }
      })
      .catch((error) => {
        console.error('Erro ao carregar permissões no homeRedirectGuard:', error);
        // Em caso de erro, redirecionar para login
        resolve(router.createUrlTree(['/login']));
      });
  });
};
